import { IAuthService } from "@/application/abstractions/auth-service.interface";
import { AuthApiRepository } from "@/infrastructure/repositories/api/auth/auth-api.repository";
import { servicesErrorHandler } from "../service-error-handler";
import {
  AuthEmailVerificationError,
  AuthLoginError,
  AuthRegistrationError,
  AuthSessionNotFoundError,
} from "@/domain/errors/auth";
import {
  AuthStorageRepository,
  UserStorageRepository,
} from "@/infrastructure/repositories/storage/user-storage.repository";

export const AuthService: IAuthService = {
  async login(credentials) {
    try {
      const { refresh_token, access_token } =
        await AuthApiRepository.login(credentials);
      AuthStorageRepository.setRefreshToken(refresh_token);
      AuthStorageRepository.setAccessToken(access_token);
    } catch (error) {
      throw servicesErrorHandler(error, new AuthLoginError());
    }
  },
  async register(data) {
    try {
      await AuthApiRepository.register(data);
      UserStorageRepository.setEmail(data.email);
    } catch (error) {
      throw servicesErrorHandler(error, new AuthRegistrationError());
    }
  },
  async logout() {
    try {
      AuthStorageRepository.clearTokens();
      await AuthApiRepository.logout();
    } catch (error) {
      throw servicesErrorHandler(error, new AuthSessionNotFoundError());
    }
  },
  async verifyEmail(data) {
    try {
      await AuthApiRepository.verifyEmail(data);
    } catch (error) {
      throw servicesErrorHandler(error, new AuthEmailVerificationError());
    }
  },
  async resendVerificationEmail(email: string) {
    if (!email || email.trim() === "")
      throw new AuthEmailVerificationError();

    try {
      await AuthApiRepository.resetVerificationEmail(email);
    } catch (error) {
      throw servicesErrorHandler(error, new AuthEmailVerificationError());
    }
  },
  getAuthenticatedState() {
    const accessToken = AuthStorageRepository.getAccessToken();
    return accessToken != null && accessToken != "";
  },
};
